<template>
  <div>
    <el-form :model="query" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="结算单号">
            <el-input
              v-model="query.receivableSettlementNo"
              placeholder="请输入结算单号"
              :disabled="isDisabledBtn"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input
              v-model="query.vehicleNoLike"
              placeholder="请输入车牌号"
              :disabled="isDisabledBtn"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="searchBtnClick" type="primary" :disabled="isDisabledBtn"
            >搜索</el-button
          >
          <el-button @click="resetBtnClick" type="primary" :disabled="isDisabledBtn"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 20px">
      <el-button type="danger" @click="deleteBtnHandler" :disabled="isDisabledBtn">删除</el-button>
    </div>
    <vxe-grid
      border
      resizable
      show-overflow
      height="200"
      :data="tableData"
      size="mini"
      ref="ruleTable"
      :columns="columnListDefault"
      align="center"
      auto-resize
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      :show-footer="true"
      :footer-method="footerMethodTotal"
    >
    </vxe-grid>
  </div>
</template>

<script>
  import { defaultColumnListDefault } from './index.js';
  export default {
    name: 'StatementDetailTable',
    props: {
      selectRowList: {
        type: Array,
        default: () => [],
      },
      invoiceNum: {
        type: String,
        default: '', // 编辑的时候
      },
      isDisabledBtn: {
        type: Boolean,
        default: false,
      },
      clearStatementDetailTable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        query: {
          receivableSettlementNo: '',
          vehicleNoLike: '',
        },
        menuButtonList: [
          {
            label: '删除',
            type: '0',
            attributes: {
              buttonUrl: 'delete',
              buttonStyle: 'el-icon-delete',
            },
          },
        ],
        tableData: [],
        receivableSettlementLineIds: [],
        selectionList: [],
      };
    },
    computed: {
      columnListDefault() {
        return defaultColumnListDefault(this);
      },
    },
    methods: {
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['settlementQuantity'].includes(column.property)) {
              return this.replaceLastZeroStr(
                data.reduce((pre, cur) => pre + cur.settlementQuantity, 0).toFixed(2)
              );
            }
            if (['originalAmount'].includes(column.property)) {
              return this.replaceLastZeroStr(
                data.reduce((pre, cur) => pre + cur.originalAmount, 0).toFixed(2)
              );
            }
            return null;
          }),
        ];
      },
      resetBtnClick() {
        this.query = {
          receivableSettlementNo: '',
          vehicleNoLike: '',
        };
        this.selectionList = [];
        this.tableData = [];
        this.getData();
      },
      searchBtnClick() {
        this.getData();
      },
      // 获取表格数据
      async getData() {
        this.selectionList = [];
        if (!this.receivableSettlementLineIds.length) {
          return;
        }
        this.loading.startLoading();
        const postData = {
          ...this.query,
          receivableSettlementLineIds: this.receivableSettlementLineIds,
          invoiceCode: this.invoiceNum,
        };
        const {
          data: { code, data, msg },
        } = await this.$axios.post(
          '/financial/receivableSettlementLineDetail/listForSaleInvoice',
          postData
        );
        this.loading.endLoading();
        if (code == 0) {
          this.tableData = data;
          // this.$emit('deleteRowHandler', this.tableData, false);
        } else {
          this.$message.error(msg);
        }
      },
      deleteBtnHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }

        const XIDList = this.selectionList.map((item) => item.id);
        console.log(XIDList, '需要删除的id');
        const deleteReceivableSettlementLineId = this.tableData
          .filter((item) => XIDList.includes(item.id))
          .map((item) => item.receivableSettlementLineId + '');
        this.tableData = this.tableData.filter((item) => !XIDList.includes(item.id));
        // 判断是不是要抛出被删除的
        const lastReceivableSettlementLineIdList = this.tableData.map(
          (item) => item.receivableSettlementLineId + ''
        );
        const deleteIdList = deleteReceivableSettlementLineId.filter(
          (item) => !lastReceivableSettlementLineIdList.includes(item)
        );
        console.log(deleteIdList);
        this.$emit('deleteRowHandler', this.tableData, true, deleteIdList);
      },
      handleSizeChange() {},
      handleCurrentChange() {},
      handleSelectionChange(row) {
        console.log(row.selection);
        this.selectionList = row.selection;
      },
    },
    watch: {
      selectRowList: {
        handler(val, oldValue) {
          console.log(val, '监听到');
          if (val && Array.isArray(val) && val.length) {
            console.log('进来了');
            this.receivableSettlementLineIds = val.map((item) => item.receivableSettlementLineId);
            setTimeout(() => {
              if (val != oldValue) {
                this.getData();
              }
            }, 1000);
          } else {
            this.receivableSettlementLineIds = [];
            this.tableData = [];
          }
        },
        immediate: true,
        deep: true,
      },
      invoiceNum: {
        handler(val) {
          if (val) {
            this.getData();
          }
        },
        immediate: true,
      },
      clearStatementDetailTable: {
        handler(val) {
          if (val) {
            this.tableData = [];
          }
        },
        immediate: true,
      },
      tableData: {
        handler(val) {
          console.log(val, '监听表格数据');
          if (val && val.length) {
            this.$emit('isTableDataHandler', true);
          } else {
            this.$emit('isTableDataHandler', false);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
